import useIncludeAirportsManager from '@/src/hooks/srp/includeAirportsManager'
import { IncludeAirportsFilter } from './includeAirportsFilter'

const IncludeAirportsFilterWrapper = () => {
    const { title, nbAirportOptions, handleSelectToggle, handleReset, shouldShowReset } = useIncludeAirportsManager()
    if (!nbAirportOptions?.length) return null
    return (
        <IncludeAirportsFilter
            includeAirports={nbAirportOptions}
            onAirportSelect={handleSelectToggle}
            onReset={handleReset}
            shouldShowReset={shouldShowReset}
            title={title}
        />
    )
}

export { IncludeAirportsFilterWrapper }
export default IncludeAirportsFilterWrapper
